// removed by extract-text-webpack-plugin
module.exports = {"loader":"Spinner_loader_3OHOW","circular":"Spinner_circular_19vQA","rotate":"Spinner_rotate_lZva_","path":"Spinner_path_XuAYn","dash":"Spinner_dash_1moG0"};